import subscriptions from './subscriptions';

export default {
  namespaced: true,
  modules: {
    subscriptions,
  },
};
